var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.839,
    height: 20.841,
    viewBox: "0 0 20.839 20.841",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.585.913a3.116,3.116,0,0,0-4.406,0L1.827,13.265a.692.692,0,0,0-.178.3L.025,19.433a.692.692,0,0,0,.852.852l5.864-1.625a.692.692,0,0,0,.3-.178L19.4,6.131a3.119,3.119,0,0,0,0-4.406Zm-15.25,12.8L13.445,3.605l3.26,3.26L6.6,16.975Zm-.651,1.307,2.6,2.6-3.6,1ZM18.419,5.152l-.734.734L14.424,2.626l.735-.734a1.731,1.731,0,0,1,2.448,0l.813.812a1.733,1.733,0,0,1,0,2.448Z",
    transform: "matrix(1, -0.026, 0.026, 1, 0, 0.537)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.deebfa2c215a5ffb0fc7618f5e18e2cf.svg";
export { ForwardRef as ReactComponent };